import { makeAutoObservable } from 'mobx';
import { id } from '@monorepo/tools/src/lib/types/primitives';

export interface IPretargeting {
	billing_id: id;
	name: string;
}

/**
 * Not observable for now
 */
export class PretargetingModel implements IPretargeting {
	billing_id: id;
	name: string;

	constructor({ billing_id, name }: IPretargeting) {
		this.billing_id = billing_id;
		this.name = name;
		makeAutoObservable(this);
	}

	getBillingId(): id {
		return this.billing_id;
	}

	getName(): string {
		return this.name;
	}
}
